module.exports = __webpack_public_path__ + "static/media/loader.5ca3c0b7.svg";